import { apiFetch } from "./client";

export interface ReportRow {
  id: string;
  channelConfigId: string;
  reportDate: string;
  messageCount: number;
  summaryMarkdown: string;
  summaryStructured: string | null;
  createdAt: string;
  sourceChannelId: string;
}

export interface StatTile {
  label: string;
  value: string;
}

export interface Finding {
  severity: "breach" | "trend" | "watch" | "positive";
  title: string;
  body: string;
  source?: string;
}

export interface ReportPayload {
  headline: string;
  lede: string;
  stats: [StatTile, StatTile, StatTile];
  findings: Finding[];
  actions: string[];
}

export async function listReports(params?: {
  channelConfigId?: string;
  reportDate?: string;
}): Promise<ReportRow[]> {
  const q = new URLSearchParams();
  if (params?.channelConfigId) q.set("channelConfigId", params.channelConfigId);
  if (params?.reportDate) q.set("reportDate", params.reportDate);
  const suffix = q.toString() ? `?${q}` : "";
  const data = await apiFetch<{ reports: ReportRow[] }>(`/api/reports${suffix}`);
  return data.reports;
}

export async function getReport(id: string): Promise<ReportRow | null> {
  try {
    const data = await apiFetch<{ report: ReportRow }>(`/api/reports/${id}`);
    return data.report;
  } catch {
    return null;
  }
}

export async function runReport(configId: string, date?: string) {
  return apiFetch("/api/reports/run", {
    method: "POST",
    json: { configId, ...(date ? { date } : {}) },
  });
}

export function parseStructured(row: ReportRow): ReportPayload | null {
  if (!row.summaryStructured) return null;
  try {
    return JSON.parse(row.summaryStructured) as ReportPayload;
  } catch {
    return null;
  }
}
